import * as React from "react";
/* empty css           */
const _Input = class _Input extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      value: this.props.initialValue || "",
      isTouched: false
    };
    this.handleChange = (event) => {
      const { currentTarget } = event;
      const { pattern, value } = currentTarget;
      const regex = pattern ? new RegExp(pattern) : null;
      if (regex && !regex.test(value)) {
        return;
      }
      if (value !== this.state.value) {
        this.setState({ value });
      }
      event.preventDefault();
    };
    this.onChange = () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    };
    this.handleBlur = () => {
      if (!this.state.isTouched) {
        this.setState({ isTouched: true }, this.onBlur);
      } else {
        this.onBlur();
      }
    };
    this.onBlur = () => {
      if (this.props.onBlur) {
        this.props.onBlur(this.state);
      }
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.setState({ value: this.props.initialValue || "" });
    }
    if (prevState.value !== this.state.value) {
      this.onChange();
    }
  }
  render() {
    const {
      type,
      className,
      "data-t": dataT,
      id,
      inputRef,
      max,
      min,
      // Omit initialValue from the input props
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      initialValue,
      ...rest
    } = this.props;
    const { value } = this.state;
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        ...rest,
        name: id,
        type,
        className,
        "data-t": dataT,
        value,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        min: type === "number" ? min : void 0,
        max: type === "number" ? max : void 0,
        ref: inputRef
      }
    );
  }
};
_Input.defaultProps = {
  id: "",
  "data-t": "",
  type: "text",
  placeholder: void 0,
  initialValue: "",
  disabled: false
};
let Input = _Input;
export {
  Input as default
};
//# sourceMappingURL=Input.js.map
